import { SignInResponse } from '../types';

export enum UserStorage {
  AUTH = 'Authenticated',
  MESSAGE = 'message',
  USER_ID = 'userId',
  TOKEN = 'token',
  REF_TOKEN = 'refreshToken',
  NAME = 'name',
}

export const recordUserData = (data: SignInResponse) => {
  localStorage.setItem(UserStorage.MESSAGE, `${data.message}`);
  localStorage.setItem(UserStorage.NAME, `${data.name}`);
  localStorage.setItem(UserStorage.REF_TOKEN, `${data.refreshToken}`);
  localStorage.setItem(UserStorage.TOKEN, `${data.token}`);
  localStorage.setItem(UserStorage.USER_ID, `${data.userId}`);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const getUserStorageData = () => ({
  message: localStorage.getItem(UserStorage.MESSAGE),
  token: localStorage.getItem(UserStorage.TOKEN),
  refreshToken: localStorage.getItem(UserStorage.REF_TOKEN),
  name: localStorage.getItem(UserStorage.NAME),
  userId: localStorage.getItem(UserStorage.USER_ID),
});

export const userIsStorage = () => localStorage.getItem(UserStorage.MESSAGE) === UserStorage.AUTH;
export const userIsLogged = (message: string | null | undefined) => message === UserStorage.AUTH;
export const getUserId = () => localStorage.getItem(UserStorage.USER_ID);
export const getUserToken = () => localStorage.getItem(UserStorage.TOKEN);
